import type { Control, FieldErrors, UseFormRegister } from "react-hook-form";

import FormInputSelect from "components/Form/Input/Select";
import FormInputSortCode from "components/Form/Input/SortCode";
import type { Applicant, DebtConsolidationFormValues } from "../types";
import FormInputText from "components/Form/Input/Text";

type Props = {
  control: Control<DebtConsolidationFormValues>;
  register: UseFormRegister<DebtConsolidationFormValues>;
  applicants: Applicant[];
  errors: FieldErrors<DebtConsolidationFormValues>;
};

export default function CustomerBankDetailsSection({
  control,
  register,
  applicants,
  errors,
}: Props) {
  return (
    <div className="mb-8">
      <div className="mb-4">
        <h3 className="text-md mb-1 font-semibold">Customer Bank Details</h3>
        <p className="mb-2 text-sm text-brand-copy-light">
          Please insert the customer bank account where cash out funds will be
          disbursed.
        </p>
      </div>

      <div className="mb-4 rounded-lg border border-gray-200 bg-white px-5 py-5">
        <div className="flex flex-wrap gap-5">
          <div className="min-w-[200px] flex-1">
            <FormInputSelect
              initSelect
              initSelectLabel="-- Select applicant --"
              id="cashOutApplicantUuid"
              label="Applicant"
              options={applicants.map((a) => ({
                value: a.uuid,
                title: `${a.forename} ${a.surname}`,
              }))}
              register={register}
              requiredField={false}
              error={errors.cashOutApplicantUuid?.message}
            />
          </div>
          <div className="min-w-[200px] flex-1">
            <FormInputText
              id="cashOutAccountNumber"
              label="Account Number"
              placeholder="01234567"
              register={register}
              requiredField={false}
              error={errors.cashOutAccountNumber?.message}
            />
          </div>
          <div className="min-w-[200px] flex-1">
            <FormInputSortCode
              control={control}
              name="cashOutSortCode"
              id="cashOutSortCode"
              label="Sort Code"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
